import type { Option } from '@branchjs/neo-components';

/**
 * Default browser option used as a fallback or initial state.
 *
 * @type {Option}
 * @typedef {Object} Option
 * @property {string} value - The internal value representing the browser.
 * @property {string} label - The display label for the browser.
 */
export const DEFAULT_BROWSER: Option = { value: 'all-browsers', label: 'All Browsers' };
